module.exports = __webpack_public_path__ + "static/media/add.19131d44.svg";